import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=1283b10c"
import script from "./Calls.vue?vue&type=script&lang=js"
export * from "./Calls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports